import castArray from "lodash/castArray"
import intersection from "lodash/intersection"
import kebabCase from "lodash/kebabCase"
import isEmpty from "lodash/isEmpty"
import { matchesPriceBounds, toComparablePrice } from "./priceFilter"

export function inPriceRanges(priceRanges, { minimumPrice }) {
  if (isEmpty(priceRanges)) return true

  const price = toComparablePrice(minimumPrice)
  if (price === null) return false

  const ranges = castArray(priceRanges).map(range => {
    const [rawMin, rawMax] = String(range).split("_")
    const min = toComparablePrice(rawMin)
    const max = toComparablePrice(rawMax)

    return {
      min: min !== null && min >= 0 ? min : null,
      max: max !== null && max >= 0 ? max : null
    }
  })

  return ranges.some(({ min, max }) => matchesPriceBounds({ price, minPrice: min, maxPrice: max }))
}

export function hasJobType(jobType, car) {
  if (isEmpty(jobType)) return true

  const selectedTypes = castArray(jobType)

  return (
    (selectedTypes.includes("company") && car.availableForCompany) ||
    (selectedTypes.includes("freelance") && car.availableForFreelance) ||
    (selectedTypes.includes("employee") && car.availableForEmployee)
  )
}

export function hasFuelType(fuel, car) {
  if (isEmpty(fuel)) return true

  const selectedFuels = castArray(fuel)

  // If we select "petrol" | "diesel" we want an exact match
  if (car.fuel === "petrol") return selectedFuels.includes("petrol")
  if (car.fuel === "diesel") return selectedFuels.includes("diesel")

  // Else check for hybrid just in case
  return selectedFuels.includes("hybrid")
}

export function hasBrand(brand, car) {
  if (isEmpty(brand)) return true

  return castArray(brand).includes(kebabCase(car.brand))
}

export function isKind(kind, car) {
  if (isEmpty(kind)) return true

  return !isEmpty(intersection(car.kind, castArray(kind)))
}

const usedStatuses = ["pre-owned", "used"]

export function hasDuration(duration, car) {
  if (typeof duration !== "number" && isEmpty(duration)) return true
  if (usedStatuses.includes(car.sellingStatus)) return true

  return !isEmpty(intersection(car.durationsIncluded, castArray(duration)))
}

export function hasKilometers(kilometers, car) {
  if (isEmpty(kilometers)) return true

  return !isEmpty(intersection(car.kmsYearIncluded, castArray(kilometers)))
}

export function hasTransmission(transmission, car) {
  return !transmission || car.transmission === transmission
}

export function hasQuotedPrice(minPrice, maxPrice, car) {
  return matchesPriceBounds({ price: car.minimumPrice, minPrice, maxPrice })
}

export function isFastDelivering(tags, car) {
  if (isEmpty(tags)) return true

  return car.fastDelivering
}

export function inProvince(provinces, car) {
  if (isEmpty(provinces)) return true

  return !isEmpty(intersection(car.humanizedDeliveryProvinces, castArray(provinces)))
}
